import * as React from 'react';
import styled from '@emotion/styled';
import { TableColumn, TableRow } from './TableWidget';

export interface TableColumnWidgetProps<T extends TableRow> {
  column: TableColumn<T>;
}

export class TableColumnWidget<T extends TableRow = TableRow> extends React.Component<TableColumnWidgetProps<T>> {
  render() {
    return (
      <S.Container right={this.props.column.right!!} shrink={this.props.column.shrink || false}>
        {this.props.column.display}
      </S.Container>
    );
  }
}

namespace S {
  export const Container = styled.th<{ shrink: boolean; right: boolean }>`
    text-align: ${(p) => (p.right ? 'right' : 'left')};
    padding: 10px 10px;
    ${(p) => (p.shrink ? `width: 1%` : '')};
    user-select: none;
    white-space: nowrap;
  `;
}
